import { AddToCollectionRequest, BatchAddDriveItemsCommand } from '@/drive/entities/DriveDestinationCommand';
import { TransientDriveItem } from '@/drive/entities/transientDriveItem';
import { toAccessInheritanceSubject } from '@/drive/helpers/toAccessInheritanceSubject';
import { AccessInheritanceSubject } from '@/drive/types/AccessInheritanceSubject';
import { DriveItemRequest } from '@/drive/types/DriveItemRequest';
import { PinnedItem } from '@/forwarding/entities/PinnedItem/PinnedItem';
import { PinnedProduct } from '@/forwarding/entities/PinnedItem/PinnedProduct';

export class PinnedItemsBatchAddCommand extends BatchAddDriveItemsCommand {
  readonly requests: DriveItemRequest[];

  readonly collectionRequest: Nullable<AddToCollectionRequest>;

  constructor(
    pinnedItems: PinnedItem[],
    private readonly loadingDtoItems: Promise<Nullable<TransientDriveItem>[]>,
  ) {
    super();

    this.requests = pinnedItems
      .map((item) => item.toDriveItemRequest())
      .map((item) => ({ ...item, id: undefined, copyFrom: item.id, type: item.type }));

    this.collectionRequest = PinnedItemsBatchAddCommand.getAddToCollectionRequest(pinnedItems);
  }

  async getAccessSubjects(): Promise<AccessInheritanceSubject[]> {
    const dtoItems = await this.loadingDtoItems;

    return dtoItems
      .filter((item): item is TransientDriveItem => item !== null)
      .map(toAccessInheritanceSubject)
      .filter((subject): subject is AccessInheritanceSubject => subject !== null);
  }

  getSourceItems(): Promise<Nullable<TransientDriveItem>[]> {
    return this.loadingDtoItems;
  }

  private static getAddToCollectionRequest(pinnedItems: PinnedItem[]): Nullable<AddToCollectionRequest> {
    const products = pinnedItems.filter((item): item is PinnedProduct => item instanceof PinnedProduct);

    if (products.length === 0 || products.length !== pinnedItems.length) {
      return null;
    }

    const productType = products[0].productType;

    if (!products.every((item) => item.productType === productType)) {
      return null;
    }

    return { productType, productIds: products.map((item) => item.productId) };
  }
}
